<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone() && viewMode() === 'table') {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="12rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="18rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="8rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Venta</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Cliente</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600">Vencimiento</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600">Compromiso</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600 hidden sm:table-cell">Correo</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600 hidden sm:table-cell">Bitácora</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600 hidden md:table-cell">Método</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Subtotal</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Total</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2">
                  <div class="flex items-center gap-2">
                    <p-skeleton shape="circle" size="2.5rem" />
                    <p-skeleton width="6rem" height="0.875rem" />
                  </div>
                </td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-center"><p-skeleton width="5rem" height="0.875rem" class="inline-block" /></td>
                <td class="px-2 py-2 text-center"><p-skeleton width="5rem" height="0.875rem" class="inline-block" /></td>
                <td class="px-2 py-2 text-center hidden sm:table-cell"><p-skeleton shape="circle" size="1rem" class="inline-block" /></td>
                <td class="px-2 py-2 text-center hidden sm:table-cell"><p-skeleton shape="circle" size="1rem" class="inline-block" /></td>
                <td class="px-2 py-2 hidden md:table-cell"><p-skeleton width="6rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="5rem" height="0.875rem" class="inline-block" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="5rem" height="0.875rem" class="inline-block" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  @if (error() && !loading() && viewMode() === 'table') {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <i class="pi pi-exclamation-circle text-red-600 mr-2"></i>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        type="button"
        (click)="load()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && (!error() || viewMode() === 'board')) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-amber-100 text-amber-600">
                  <i class="pi pi-wallet"></i>
                </span>
                Cobranza
              </h2>
              <p class="text-sm text-slate-500 mt-1">
                @if (viewMode() === 'table') {
                  Recibos pendientes
                } @else {
                  Tablero de paneles filtrados
                }
                <span class="text-slate-400"> · Al {{ asOfLabel() }}</span>
              </p>
            </div>
            <span class="inline-flex justify-self-center rounded-lg border border-slate-200 bg-white p-0.5 shadow-sm" role="group" aria-label="Tipo de vista">
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-sky-100]="viewMode() === 'table'"
                [class.text-sky-800]="viewMode() === 'table'"
                [class.text-slate-600]="viewMode() !== 'table'"
                (click)="setViewMode('table')"
                pTooltip="Vista tabla"
                tooltipPosition="bottom"
              >
                <i class="pi pi-table"></i>
                <span class="hidden sm:inline">Tabla</span>
              </button>
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-sky-100]="viewMode() === 'board'"
                [class.text-sky-800]="viewMode() === 'board'"
                [class.text-slate-600]="viewMode() !== 'board'"
                (click)="setViewMode('board')"
                pTooltip="Vista tablero con paneles guardados"
                tooltipPosition="bottom"
              >
                <i class="pi pi-th-large"></i>
                <span class="hidden sm:inline">Tablero</span>
              </button>
            </span>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              @if (viewMode() === 'board') {
                <p-button
                  label="Nuevo panel"
                  icon="pi pi-plus"
                  severity="primary"
                  size="small"
                  (onClick)="openCreatePanelDialog()" />
              }
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="viewMode() === 'board' ? boardRefreshing() : loading()"
                (onClick)="load()"
                pTooltip="Actualizar listado"
                tooltipPosition="left"
                appendTo="body" />
            </div>
          </div>
        </div>

        @if (viewMode() === 'table') {
          <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
            <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
              <div class="min-w-0 xl:w-36">
                <p-floatlabel class="w-full" variant="on">
                  <p-iconfield class="w-full">
                    <input pInputText id="filterCollectionsSale" formControlName="saleNumber" class="w-full p-inputtext-sm" autocomplete="off" />
                    @if (filtersForm.controls.saleNumber.value) {
                      <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.saleNumber.setValue('', { emitEvent: false }); applyFilters()" />
                    }
                  </p-iconfield>
                  <label for="filterCollectionsSale">Venta</label>
                </p-floatlabel>
              </div>
              <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-48">
                <p-floatlabel class="w-full" variant="on">
                  <p-iconfield class="w-full">
                    <input pInputText id="filterCollectionsCustomer" formControlName="customerName" class="w-full p-inputtext-sm" autocomplete="off" />
                    @if (filtersForm.controls.customerName.value) {
                      <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.customerName.setValue('', { emitEvent: false }); applyFilters()" />
                    }
                  </p-iconfield>
                  <label for="filterCollectionsCustomer">Cliente</label>
                </p-floatlabel>
              </div>
              <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
                <p-datepicker
                  inputId="filterCollectionsDueDate"
                  formControlName="dueDateRange"
                  selectionMode="range"
                  [readonlyInput]="true"
                  dateFormat="dd/mm/yy"
                  showIcon
                  iconDisplay="input"
                  [showClear]="true"
                  size="small"
                  class="w-full" />
                <label for="filterCollectionsDueDate">Rango F. vencimiento</label>
              </p-floatlabel>
              <p-floatlabel class="w-full min-w-0 xl:w-44" variant="on">
                <p-select
                  formControlName="collectionMethod"
                  inputId="filterCollectionsMethod"
                  [options]="collectionMethodOptions"
                  optionLabel="label"
                  optionValue="value"
                  size="small"
                  [showClear]="true"
                  class="w-full" />
                <label for="filterCollectionsMethod">Método de pago</label>
              </p-floatlabel>
              <p-floatlabel class="w-full min-w-0 xl:w-36" variant="on">
                <p-select
                  formControlName="bucket"
                  inputId="filterCollectionsBucket"
                  [options]="bucketFilterOptions"
                  optionLabel="label"
                  optionValue="value"
                  size="small"
                  class="w-full" />
                <label for="filterCollectionsBucket">Estado</label>
              </p-floatlabel>
              @if (hasActiveFilters()) {
                <div class="flex items-end col-span-2 sm:col-span-1">
                  <p-button
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    size="small"
                    severity="secondary"
                    type="button"
                    (onClick)="clearFilters()"
                    ariaLabel="Limpiar filtros" />
                </div>
              }
            </div>
          </div>

          <div class="flex-1 min-h-0 overflow-hidden">
            <p-table
              [value]="charges()"
              [lazy]="true"
              [paginator]="true"
              [rows]="pageSize()"
              [first]="currentPage() * pageSize()"
              [totalRecords]="totalItems()"
              [rowsPerPageOptions]="pageSizeOptions"
              [scrollable]="true"
              scrollHeight="flex"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} recibos"
              [loading]="loading()"
              sortMode="single"
              [sortField]="sortField()"
              [sortOrder]="sortOrder()"
              (onLazyLoad)="onLazyLoad($event)"
              [tableStyle]="{ width: '100%' }"
              styleClass="collections-primeng-table p-datatable-striped p-datatable-sm"
              [rowHover]="true"
              paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between"
            >
              <ng-template pTemplate="paginatorleft">
                <span
                  class="inline-flex"
                  [pTooltip]="exportButtonTooltip"
                  tooltipPosition="top"
                  appendTo="body">
                  <p-button
                    label="Exportar CSV"
                    icon="pi pi-download"
                    severity="secondary"
                    size="small"
                    [rounded]="true"
                    [loading]="exporting()"
                    [disabled]="!canExportCharges || exporting() || totalItems() === 0"
                    (onClick)="exportCsv()" />
                </span>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th class="!px-2" pSortableColumn="sale.number">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Venta</span>
                      @if (sortField() === 'sale.number') {
                        <p-sortIcon field="sale.number" />
                      }
                    </span>
                  </th>
                  <th class="!px-2" pSortableColumn="customer.comercialName">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Cliente</span>
                      @if (sortField() === 'customer.comercialName') {
                        <p-sortIcon field="customer.comercialName" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 !whitespace-nowrap !text-center" pSortableColumn="dueDate">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Vencimiento</span>
                      @if (sortField() === 'dueDate') {
                        <p-sortIcon field="dueDate" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 !whitespace-nowrap !text-center" pSortableColumn="cxc.commitmentDate">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Compromiso</span>
                      @if (sortField() === 'cxc.commitmentDate') {
                        <p-sortIcon field="cxc.commitmentDate" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 hidden sm:table-cell !whitespace-nowrap !text-center" pSortableColumn="cxc.email">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Correo</span>
                      @if (sortField() === 'cxc.email') {
                        <p-sortIcon field="cxc.email" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 hidden sm:table-cell !whitespace-nowrap !text-center" pSortableColumn="cxc.internal">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Bitácora</span>
                      @if (sortField() === 'cxc.internal') {
                        <p-sortIcon field="cxc.internal" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 hidden md:table-cell !whitespace-nowrap" pSortableColumn="collectionMethod">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Método</span>
                      @if (sortField() === 'collectionMethod') {
                        <p-sortIcon field="collectionMethod" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="subtotal">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Subtotal</span>
                      @if (sortField() === 'subtotal') {
                        <p-sortIcon field="subtotal" />
                      }
                    </span>
                  </th>
                  <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="total">
                    <span class="inline-flex items-center justify-between gap-1.5 w-full">
                      <span>Total</span>
                      @if (sortField() === 'total') {
                        <p-sortIcon field="total" />
                      }
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-c>
                <tr
                  class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100"
                  [class.opacity-60]="chargeDetailsLoading()"
                  (click)="openChargeDetails(c)">
                  <td class="!px-2 !py-2 !border-slate-100" (click)="$event.stopPropagation()">
                    <div class="flex items-center gap-1.5 min-w-0">
                      <div class="relative shrink-0 h-8 w-8 overflow-visible flex items-center justify-center">
                        <p-button
                          icon="pi pi-envelope"
                          [rounded]="true"
                          [text]="true"
                          severity="secondary"
                          type="button"
                          styleClass="hover:!bg-sky-100 shrink-0"
                          aria-label="Seguimiento por email"
                          pTooltip="Seguimiento"
                          tooltipPosition="top"
                          appendTo="body"
                          [disabled]="!c.id"
                          (onClick)="openSeguimientoDialog($event, c)"
                        />
                        @if (cxcStatusBadge(c); as badge) {
                          <span
                            class="cxc-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-10 h-[16px] w-[16px] rounded-full text-white ring-2 ring-white shadow"
                            [ngClass]="badge.badgeClass"
                            [pTooltip]="badge.tooltip"
                            tooltipPosition="top"
                            appendTo="body"
                          >
                            <i [class]="badge.icon + ' !text-[9px]'"></i>
                          </span>
                        }
                      </div>
                      <div class="min-w-0">
                        @if (c.saleId || c.sale?.id) {
                          <button
                            type="button"
                            class="text-sm font-medium text-slate-900 hover:text-violet-700 truncate"
                            (click)="openSaleDetails(c.saleId ?? c.sale?.id, $event)">
                            {{ saleNumberLabel(c) }}
                          </button>
                        } @else {
                          <span class="text-sm text-slate-400">—</span>
                        }
                      </div>
                    </div>
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]" (click)="$event.stopPropagation()">
                    <div class="min-w-0">
                      @if (c.customerId || c.sale?.customer?.id) {
                        <button
                          type="button"
                          class="block w-full text-left text-sm text-slate-900 truncate hover:text-sky-700"
                          [pTooltip]="customerName(c)"
                          tooltipPosition="top"
                          (click)="openCustomerDetails(c.customerId ?? c.sale?.customer?.id, $event)">
                          {{ customerName(c) }}
                        </button>
                      } @else {
                        <span
                          class="block text-sm text-slate-600 truncate"
                          [pTooltip]="customerName(c)"
                          tooltipPosition="top"
                        >{{ customerName(c) }}</span>
                      }
                    </div>
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
                    @let days = daysUntilDue(c.dueDate);
                    <span
                      class="tabular-nums text-sm"
                      [class.text-rose-700]="days != null && days < 0"
                      [class.font-medium]="days != null && days < 0"
                      [class.text-slate-800]="days == null || days >= 0"
                      [pTooltip]="days != null && days < 0 ? daysLabel(days) : ''"
                      [tooltipDisabled]="days == null || days >= 0"
                      tooltipPosition="top"
                      [class.cursor-help]="days != null && days < 0">
                      {{ c.dueDate ? (c.dueDate | date:'dd/MM/yyyy') : '—' }}
                    </span>
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
                    @if (c.cxc?.commitmentDate; as commitmentDate) {
                      <span
                        class="inline-flex items-center justify-center gap-1 tabular-nums text-sm"
                        [class.text-rose-700]="isBrokenPaymentCommitment(c)"
                        [class.font-medium]="isBrokenPaymentCommitment(c)"
                        [class.text-slate-800]="!isBrokenPaymentCommitment(c)"
                        [pTooltip]="isBrokenPaymentCommitment(c) ? 'Compromiso vencido' : 'Fecha compromiso de pago'"
                        tooltipPosition="top"
                        appendTo="body"
                      >
                        @if (isBrokenPaymentCommitment(c)) {
                          <i class="pi pi-exclamation-triangle text-[11px]" aria-hidden="true"></i>
                        }
                        {{ formatCommitmentDate(commitmentDate) }}
                      </span>
                    } @else {
                      <span class="text-slate-300 text-sm">—</span>
                    }
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell !text-center">
                    @if (c.cxc?.email) {
                      <span
                        class="inline-flex items-center justify-center text-sky-500"
                        [pTooltip]="cxcEmailCheckTooltip(c)"
                        tooltipPosition="top"
                        appendTo="body">
                        @if (c.cxc?.emailOpened) {
                          <i class="pi pi-check text-sm -mr-1.5"></i>
                          <i class="pi pi-check text-sm"></i>
                        } @else {
                          <i class="pi pi-check text-sm text-slate-400"></i>
                        }
                      </span>
                    } @else {
                      <span class="text-slate-300 text-sm">—</span>
                    }
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell !text-center">
                    @if (c.cxc?.internal) {
                      <i
                        class="pi pi-check text-sm text-emerald-600"
                        [pTooltip]="cxcInternalCheckTooltip(c)"
                        tooltipPosition="top"
                        appendTo="body"></i>
                    } @else {
                      <span class="text-slate-300 text-sm">—</span>
                    }
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 hidden md:table-cell text-sm text-slate-600 !whitespace-nowrap">
                    {{ methodLabel(c.collectionMethod) }}
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right tabular-nums">
                    {{ (c.subtotal ?? 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}
                  </td>
                  <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right tabular-nums">
                    {{ (c.total ?? 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                    No se encontraron recibos con el filtro aplicado.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }

        @if (viewMode() === 'board') {
          <div class="flex-1 min-h-0 overflow-auto bg-slate-50/60 p-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
              @for (panel of boardPanels(); track panel.id) {
                @let result = panelResult(panel.id);
                <section
                  class="group flex flex-col rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden transition-all hover:border-amber-300 hover:shadow-md focus-within:border-amber-300"
                  [class.opacity-70]="result.loading"
                  [class.cursor-pointer]="!result.loading && !result.error"
                  [class.cursor-default]="result.loading || !!result.error"
                  (click)="!result.loading && !result.error && openPanelChargesDrawer(panel)"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="!result.loading && !result.error && openPanelChargesDrawer(panel)">
                  <header class="shrink-0 px-4 pt-3.5 pb-2">
                    <div class="flex items-start justify-between gap-2">
                      <div class="min-w-0">
                        <h3
                          class="text-sm font-semibold text-slate-900 line-clamp-2 break-words"
                          [pTooltip]="panel.title"
                          tooltipPosition="top"
                          [showDelay]="400">
                          {{ panel.title }}
                        </h3>
                        <p class="text-[10px] text-slate-400 mt-0.5">
                          {{ panel.scope === 'GLOBAL' ? 'Global' : 'Personal' }}
                        </p>
                      </div>
                      <div class="flex items-center shrink-0" (click)="$event.stopPropagation()">
                        <p-button
                          icon="pi pi-pencil"
                          [rounded]="true"
                          [text]="true"
                          size="small"
                          severity="secondary"
                          type="button"
                          (onClick)="openEditPanelDialog(panel)"
                          pTooltip="Editar panel"
                          tooltipPosition="top" />
                        <p-button
                          icon="pi pi-trash"
                          [rounded]="true"
                          [text]="true"
                          size="small"
                          severity="danger"
                          type="button"
                          (onClick)="deletePanel(panel, $event)"
                          pTooltip="Eliminar panel"
                          tooltipPosition="top" />
                      </div>
                    </div>
                  </header>

                  <div class="flex-1 px-4 pb-4 pt-1">
                    @if (result.loading) {
                      <div class="flex flex-col items-center justify-center gap-2 py-8 text-slate-500">
                        <i class="pi pi-spin pi-spinner text-xl text-sky-500"></i>
                        <span class="text-xs">Consultando…</span>
                      </div>
                    } @else if (result.error) {
                      <div class="py-6 text-center" (click)="$event.stopPropagation()">
                        <p class="text-sm text-rose-700">{{ result.error }}</p>
                        <button
                          type="button"
                          class="mt-2 text-xs font-medium text-sky-700 hover:underline"
                          (click)="loadPanelResult(panel)">
                          Reintentar
                        </button>
                      </div>
                    } @else {
                      <div class="mt-1 rounded-lg bg-amber-50/80 border border-amber-100 px-3 py-3">
                        <p class="text-[10px] font-semibold uppercase tracking-wide text-amber-700/80">Recibos</p>
                        <p class="mt-1 text-2xl font-semibold tabular-nums text-slate-900">
                          {{ result.totalItems }}
                        </p>
                      </div>
                    }
                  </div>
                </section>
              }

              <button
                type="button"
                class="flex min-h-[11rem] flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-slate-200 bg-white/70 text-slate-500 hover:border-sky-300 hover:bg-sky-50/40 hover:text-sky-700 transition-colors"
                (click)="openCreatePanelDialog()">
                <span class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100">
                  <i class="pi pi-plus"></i>
                </span>
                <span class="text-sm font-medium">Crear panel</span>
                <span class="text-xs text-slate-400 px-6 text-center">Define filtros avanzados y guarda el resultado</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  }

</div>

  <p-dialog
    [header]="editingPanelId() ? 'Editar panel' : 'Nuevo panel'"
    [visible]="panelDialogVisible()"
    (visibleChange)="onPanelDialogVisibleChange($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(40rem, 95vw)' }"
    [contentStyle]="{ overflow: 'auto' }"
    styleClass="collections-panel-dialog"
    [blockScroll]="true">
    <form [formGroup]="panelForm" class="min-w-0 pt-1" (ngSubmit)="savePanel()">
      <div class="panel-compose-sheet overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div class="panel-compose-row">
          <label class="panel-compose-label" for="panelTitle">Nombre</label>
          <div class="panel-compose-field min-w-0 flex-1">
            <input
              pInputText
              id="panelTitle"
              formControlName="title"
              class="panel-compose-input w-full"
              autocomplete="off"
              placeholder="Nombre del panel" />
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Visibilidad</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-select
              inputId="panelScope"
              formControlName="scope"
              [options]="scopeOptions"
              optionLabel="label"
              optionValue="value"
              size="small"
              styleClass="panel-compose-select w-full"
              appendTo="body" />
          </div>
        </div>

        <div class="panel-compose-section">
          <span class="panel-compose-section-label">Recibo</span>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Clientes</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-autocomplete
              inputId="panelCustomer"
              formControlName="customerSelection"
              [suggestions]="panelCustomerOptions()"
              (completeMethod)="onPanelCustomerSearch($event)"
              optionLabel="displayLabel"
              [multiple]="true"
              [unique]="true"
              dataKey="id"
              [dropdown]="false"
              [forceSelection]="true"
              [minLength]="3"
              [delay]="1000"
              appendTo="body"
              styleClass="panel-compose-autocomplete w-full"
              inputStyleClass="panel-compose-input"
              placeholder="Buscar clientes"
              fluid />
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Métodos</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-multiselect
              inputId="panelMethod"
              formControlName="collectionMethods"
              [options]="collectionMethodOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              size="small"
              [filter]="false"
              [showClear]="true"
              placeholder="Cualquiera"
              styleClass="panel-compose-multiselect w-full"
              appendTo="body" />
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Estados</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-multiselect
              inputId="panelStatuses"
              formControlName="statuses"
              [options]="statusFilterOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              size="small"
              [filter]="false"
              placeholder="Cualquiera"
              styleClass="panel-compose-multiselect w-full"
              appendTo="body" />
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Vencido</span>
          <div class="panel-compose-field panel-compose-range min-w-0 flex-1">
            <p-inputnumber
              inputId="panelOverdueFrom"
              formControlName="overdueDaysFrom"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≥"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-sep">y</span>
            <p-inputnumber
              inputId="panelOverdueTo"
              formControlName="overdueDaysTo"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≤"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-unit">días</span>
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Vence</span>
          <div class="panel-compose-field panel-compose-range min-w-0 flex-1">
            <p-inputnumber
              inputId="panelDueInFrom"
              formControlName="dueInDaysFrom"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≥"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-sep">y</span>
            <p-inputnumber
              inputId="panelDueInTo"
              formControlName="dueInDaysTo"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≤"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-unit">días</span>
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Intentos</span>
          <div class="panel-compose-field panel-compose-range min-w-0 flex-1">
            <span class="panel-compose-range-sep">≥</span>
            <p-inputnumber
              inputId="panelAttemptMin"
              formControlName="attemptCountMin"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="0"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
          </div>
        </div>

        <div class="panel-compose-section">
          <span class="panel-compose-section-label">Seguimiento</span>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Correo</span>
          <div class="panel-compose-field panel-compose-range min-w-0 flex-1">
            <p-select
              inputId="panelCxcEmail"
              formControlName="cxcEmail"
              [options]="yesNoFilterOptions"
              optionLabel="label"
              optionValue="value"
              size="small"
              [showClear]="true"
              placeholder="Sí / No"
              styleClass="panel-compose-select flex-1 min-w-0"
              appendTo="body" />
            <span class="panel-compose-range-sep">Leído</span>
            <p-select
              inputId="panelCxcEmailOpened"
              formControlName="cxcEmailOpened"
              [options]="yesNoFilterOptions"
              optionLabel="label"
              optionValue="value"
              size="small"
              [showClear]="true"
              placeholder="Sí / No"
              styleClass="panel-compose-select flex-1 min-w-0"
              appendTo="body" />
            <span class="panel-compose-range-sep">Último</span>
            <p-inputnumber
              inputId="panelLastSentEmailFrom"
              formControlName="lastSentEmailDaysFrom"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≥"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-sep">y</span>
            <p-inputnumber
              inputId="panelLastSentEmailTo"
              formControlName="lastSentEmailDaysTo"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≤"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-unit">días</span>
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Nota</span>
          <div class="panel-compose-field panel-compose-range min-w-0 flex-1">
            <p-select
              inputId="panelCxcInternal"
              formControlName="cxcInternal"
              [options]="yesNoFilterOptions"
              optionLabel="label"
              optionValue="value"
              size="small"
              [showClear]="true"
              placeholder="Sí / No"
              styleClass="panel-compose-select flex-1 min-w-0"
              appendTo="body" />
            <span class="panel-compose-range-sep">Última</span>
            <p-inputnumber
              inputId="panelLastSentInternalFrom"
              formControlName="lastSentInternalDaysFrom"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≥"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-sep">y</span>
            <p-inputnumber
              inputId="panelLastSentInternalTo"
              formControlName="lastSentInternalDaysTo"
              [min]="0"
              [useGrouping]="false"
              size="small"
              placeholder="≤"
              styleClass="panel-compose-days"
              inputStyleClass="panel-compose-input text-center" />
            <span class="panel-compose-range-unit">días</span>
          </div>
        </div>

        <div class="panel-compose-section">
          <span class="panel-compose-section-label panel-compose-section-label--sale">Venta</span>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Frecuencia</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-multiselect
              inputId="panelSaleFrequency"
              formControlName="saleFrequencies"
              [options]="saleFrequencyOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              size="small"
              [filter]="false"
              [showClear]="true"
              placeholder="Cualquiera"
              styleClass="panel-compose-multiselect w-full"
              appendTo="body" />
          </div>
        </div>

        <div class="panel-compose-row">
          <span class="panel-compose-label">Estado</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-multiselect
              inputId="panelSaleStatus"
              formControlName="saleStatuses"
              [options]="saleStatusOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              size="small"
              [filter]="false"
              [showClear]="true"
              placeholder="Cualquiera"
              styleClass="panel-compose-multiselect w-full"
              appendTo="body" />
          </div>
        </div>

        <div class="panel-compose-row panel-compose-row--last">
          <span class="panel-compose-label">Tipo</span>
          <div class="panel-compose-field min-w-0 flex-1">
            <p-multiselect
              inputId="panelSaleType"
              formControlName="saleTypes"
              [options]="saleTypeOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              size="small"
              [filter]="false"
              [showClear]="true"
              placeholder="Cualquiera"
              styleClass="panel-compose-multiselect w-full"
              appendTo="body" />
          </div>
        </div>
      </div>
      <p class="mt-2 text-[11px] text-slate-400 px-0.5">
        Vencido / Vence: un valor o el rango. No combines ambos.
      </p>
    </form>

    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2">
        <p-button
          label="Cancelar"
          severity="secondary"
          [text]="true"
          (onClick)="onPanelDialogVisibleChange(false)" />
        <p-button
          [label]="editingPanelId() ? 'Guardar cambios' : 'Guardar panel'"
          icon="pi pi-check"
          [loading]="panelSaving()"
          (onClick)="savePanel()" />
      </div>
    </ng-template>
  </p-dialog>

  <p-drawer
    [visible]="isPanelChargesDrawerOpen()"
    position="right"
    (visibleChange)="onPanelChargesDrawerVisibleChange($event)"
    styleClass="panel-charges-drawer !w-[min(920px,100vw)]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-start justify-between gap-3 min-w-0 w-full pr-2">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-amber-100 text-amber-600 shadow-sm">
            <i class="pi pi-wallet text-base"></i>
          </span>
          <div class="min-w-0">
            <h3 class="text-lg font-semibold text-slate-900 truncate">
              {{ selectedBoardPanel()?.title || 'Panel' }}
            </h3>
            <p class="text-xs text-slate-500 mt-0.5">
              {{ panelDrawerTotalItems() }} recibo{{ panelDrawerTotalItems() === 1 ? '' : 's' }}
            </p>
          </div>
        </div>
      </div>
    </ng-template>

    @if (selectedBoardPanel(); as panel) {
      <div class="px-4 py-2 border-b border-slate-200 bg-white flex flex-wrap gap-1">
        @for (chip of panelFilterChips(panel); track chip) {
          <span class="inline-flex max-w-full truncate rounded-md bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-600">
            {{ chip }}
          </span>
        }
      </div>
    }

    @if (panelDrawerError()) {
      <div class="m-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
        {{ panelDrawerError() }}
      </div>
    }

    <div class="flex-1 min-h-0 overflow-hidden bg-white">
      <p-table
        [value]="panelDrawerCharges()"
        [lazy]="true"
        [paginator]="true"
        [rows]="panelDrawerPageSize()"
        [first]="panelDrawerPage() * panelDrawerPageSize()"
        [totalRecords]="panelDrawerTotalItems()"
        [rowsPerPageOptions]="[20, 40, 80]"
        [scrollable]="true"
        scrollHeight="flex"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} recibos"
        [loading]="panelDrawerLoading()"
        (onLazyLoad)="onPanelDrawerLazyLoad($event)"
        [tableStyle]="{ width: '100%' }"
        styleClass="collections-primeng-table p-datatable-striped p-datatable-sm"
        [rowHover]="true"
        paginatorStyleClass="!border-0 !bg-transparent !pt-3 !pb-3 !px-3 !flex !justify-end"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="!px-2">Venta</th>
            <th class="!px-2">Cliente</th>
            <th class="!px-2 !whitespace-nowrap !text-center">Vencimiento</th>
            <th class="!px-2 !whitespace-nowrap !text-center">Compromiso</th>
            <th class="!px-2 hidden sm:table-cell !whitespace-nowrap !text-center">Correo</th>
            <th class="!px-2 hidden sm:table-cell !whitespace-nowrap !text-center">Bitácora</th>
            <th class="!px-2 hidden md:table-cell !whitespace-nowrap">Estado</th>
            <th class="!px-2 hidden lg:table-cell !whitespace-nowrap">Método</th>
            <th class="!px-2 !whitespace-nowrap !text-right">Subtotal</th>
            <th class="!px-2 !whitespace-nowrap !text-right">Total</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-c>
          <tr
            class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100"
            (click)="openChargeDetails(c)">
            <td class="!px-2 !py-2 !border-slate-100" (click)="$event.stopPropagation()">
              <div class="flex items-center gap-1.5 min-w-0">
                <div class="relative shrink-0 h-8 w-8 overflow-visible flex items-center justify-center">
                  <p-button
                    icon="pi pi-envelope"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    type="button"
                    styleClass="hover:!bg-sky-100 shrink-0"
                    aria-label="Seguimiento"
                    pTooltip="Seguimiento"
                    tooltipPosition="top"
                    appendTo="body"
                    [disabled]="!c.id"
                    (onClick)="openSeguimientoDialog($event, c)"
                  />
                  @if (cxcStatusBadge(c); as badge) {
                    <span
                      class="cxc-status-badge pointer-events-auto absolute -bottom-1 -right-1 z-10 h-[16px] w-[16px] rounded-full text-white ring-2 ring-white shadow"
                      [ngClass]="badge.badgeClass"
                      [pTooltip]="badge.tooltip"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <i [class]="badge.icon + ' !text-[9px]'"></i>
                    </span>
                  }
                </div>
                <div class="min-w-0">
                  @if (c.saleId || c.sale?.id) {
                    <button
                      type="button"
                      class="text-sm font-medium text-slate-900 hover:text-violet-700 truncate"
                      (click)="openSaleDetails(c.saleId ?? c.sale?.id, $event)">
                      {{ saleNumberLabel(c) }}
                    </button>
                  } @else {
                    <span class="text-sm text-slate-400">—</span>
                  }
                </div>
              </div>
            </td>
            <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]" (click)="$event.stopPropagation()">
              <div class="min-w-0">
                @if (c.customerId || c.sale?.customer?.id) {
                  <button
                    type="button"
                    class="block w-full text-left text-sm text-slate-900 truncate hover:text-sky-700"
                    [pTooltip]="customerName(c)"
                    tooltipPosition="top"
                    (click)="openCustomerDetails(c.customerId ?? c.sale?.customer?.id, $event)">
                    {{ customerName(c) }}
                  </button>
                } @else {
                  <span
                    class="block text-sm text-slate-600 truncate"
                    [pTooltip]="customerName(c)"
                    tooltipPosition="top"
                  >{{ customerName(c) }}</span>
                }
              </div>
            </td>
            <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
              @let days = daysUntilDue(c.dueDate);
              <span
                class="tabular-nums text-sm"
                [class.text-rose-700]="days != null && days < 0"
                [class.font-medium]="days != null && days < 0"
                [class.text-slate-800]="days == null || days >= 0"
                [pTooltip]="days != null && days < 0 ? daysLabel(days) : ''"
                [tooltipDisabled]="days == null || days >= 0"
                tooltipPosition="top">
                {{ c.dueDate ? (c.dueDate | date:'dd/MM/yyyy') : '—' }}
              </span>
            </td>
            <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
              @if (c.cxc?.commitmentDate; as commitmentDate) {
                <span
                  class="inline-flex items-center justify-center gap-1 tabular-nums text-sm"
                  [class.text-rose-700]="isBrokenPaymentCommitment(c)"
                  [class.font-medium]="isBrokenPaymentCommitment(c)"
                  [class.text-slate-800]="!isBrokenPaymentCommitment(c)"
                  [pTooltip]="isBrokenPaymentCommitment(c) ? 'Compromiso vencido' : 'Fecha compromiso de pago'"
                  tooltipPosition="top"
                  appendTo="body"
                >
                  @if (isBrokenPaymentCommitment(c)) {
                    <i class="pi pi-exclamation-triangle text-[11px]" aria-hidden="true"></i>
                  }
                  {{ formatCommitmentDate(commitmentDate) }}
                </span>
              } @else {
                <span class="text-slate-300 text-sm">—</span>
              }
            </td>
            <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell !text-center">
              @if (c.cxc?.email) {
                <span
                  class="inline-flex items-center justify-center text-sky-500"
                  [pTooltip]="cxcEmailCheckTooltip(c)"
                  tooltipPosition="top"
                  appendTo="body">
                  @if (c.cxc?.emailOpened) {
                    <i class="pi pi-check text-sm -mr-1.5"></i>
                    <i class="pi pi-check text-sm"></i>
                  } @else {
                    <i class="pi pi-check text-sm text-slate-400"></i>
                  }
                </span>
              } @else {
                <span class="text-slate-300 text-sm">—</span>
              }
            </td>
            <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell !text-center">
              @if (c.cxc?.internal) {
                <i
                  class="pi pi-check text-sm text-emerald-600"
                  [pTooltip]="cxcInternalCheckTooltip(c)"
                  tooltipPosition="top"
                  appendTo="body"></i>
              } @else {
                <span class="text-slate-300 text-sm">—</span>
              }
            </td>
            <td class="!px-2 !py-2 !border-slate-100 hidden md:table-cell text-sm text-slate-600 !whitespace-nowrap">
              {{ statusLabel(c.status) }}
            </td>
            <td class="!px-2 !py-2 !border-slate-100 hidden lg:table-cell text-sm text-slate-600 !whitespace-nowrap">
              {{ methodLabel(c.collectionMethod) }}
            </td>
            <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right tabular-nums">
              {{ (c.subtotal ?? 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}
            </td>
            <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right tabular-nums">
              {{ (c.total ?? 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
              No se encontraron recibos con el filtro del panel.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-drawer>

  <app-charge-read
    [charge]="selectedCharge()"
    [visible]="isDetailsOpen()"
    (visibleChange)="onDrawerVisibleChange($event)" />

  @if (seguimientoDialogChargeId(); as chargeId) {
    <app-charge-followup-dialog
      [visible]="seguimientoDialogVisible()"
      (visibleChange)="onSeguimientoDialogVisibleChange($event)"
      [chargeId]="chargeId"
      [saleId]="seguimientoDialogSaleId()"
      [subtitle]="seguimientoDialogSubtitle()"
    />
  }

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
          <i class="pi pi-shopping-cart text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-user text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>
</div>
